import { render, staticRenderFns } from "./billORtotal.vue?vue&type=template&id=12b1a90e&"
import script from "./billORtotal.vue?vue&type=script&lang=js&"
export * from "./billORtotal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports